import { render, staticRenderFns } from "./IndexWrap.vue?vue&type=template&id=044262ac"
import script from "./IndexWrap.vue?vue&type=script&lang=js"
export * from "./IndexWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports